/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);

const $titles = $el.find('[data-component="blocks/title-box"]');

$titles.on('click', function () {
    const $this = $(this);

    if ($this.is('.expanded')) {
        $this.removeClass('expanded');
        $this.addClass('retracted');
        $this.next().slideUp();
    } else {
        $this.removeClass('retracted');
        $this.addClass('expanded');
        $this.next().slideDown();
    }

    setTimeout(function () {
        $document.trigger('scroll');
    }, 200);
});

